export const SEND_STATUS = "SEND_STATUS";
export const SEND_STATUS_SUCCESS = "SEND_STATUS_SUCCESS";